import React from 'react';
import { MessageSquare, FileQuestion, TrendingUp, AlertCircle, CreditCard, Clock } from 'lucide-react';
import AnimateOnScroll from './AnimateOnScroll';
import { problemSection } from '../content/landingContent';

const iconMap = {
  0: MessageSquare,
  1: FileQuestion,
  2: TrendingUp,
  3: AlertCircle,
  4: CreditCard,
  5: Clock
};

export const ProblemSection = () => {
  return (
    <section className="py-24 lg:py-32 bg-white">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <AnimateOnScroll>
          <div className="text-center mb-16">
            <h2 className="text-2xl lg:text-3xl font-bold text-stone-900 mb-6 tracking-tight">
              {problemSection.headline}
            </h2>
            {problemSection.subheadline && (
              <p className="text-lg text-stone-600 max-w-2xl mx-auto">
                {problemSection.subheadline}
              </p>
            )}
          </div>
        </AnimateOnScroll>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {problemSection.problems.map((problem, index) => {
            const Icon = iconMap[index];
            return (
              <AnimateOnScroll key={index} delay={index * 100}>
                <div 
                  className="flex flex-col space-y-4 p-6 rounded-lg bg-white border border-stone-200 shadow-sm hover:shadow-md hover:border-slate-300 transition-all duration-300 group"
                >
                  <div className="flex items-start space-x-4">
                    <div className="flex-shrink-0">
                      <div className="w-12 h-12 rounded-lg bg-slate-100 flex items-center justify-center group-hover:bg-slate-600 transition-all duration-300">
                        <Icon className="w-6 h-6 text-slate-600 group-hover:text-white transition-colors duration-300" />
                      </div>
                    </div>
                    <h3 className="text-base font-semibold text-stone-900 leading-snug pt-2">
                      {problem.title}
                    </h3>
                  </div>
                  <p className="text-stone-600 leading-relaxed text-sm">
                    {problem.description}
                  </p>
                </div>
              </AnimateOnScroll>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;